import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import ADMIN_FOOTER from "../Admin_Footer";
import axios from "axios";
import BannerSortModal from "../../../admin_resources/js/BannerSortModal.js";

const Admin_banner = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]); // 현재 화면에 표시되는 배너
  const [allBanners, setAllBanners] = useState([]); // 전체 배너 데이터
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [previewBanner, setPreviewBanner] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // 검색어 상태
  const [searchOption, setSearchOption] = useState("title"); // 검색 기준: 'title' 또는 'writer_id'
  const [showSortModal, setShowSortModal] = useState(false);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    // 처음 데이터 로딩
    const fetchBanners = async () => {
      try {
        const response = await axios.get("/bplist");
        const filteredBanners = response.data.filter(
          (banner) => banner.gubun === "BN01"
        );

        const sortedBanners = filteredBanners.sort((a, b) => {
          return new Date(b.logDate) - new Date(a.logDate);
        });

        setBanners(sortedBanners);
        setAllBanners(sortedBanners); // 전체 배너 데이터도 저장
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();

    // 관리자 권한 정보 가져오기
    const adminId = localStorage.getItem("adminId");
    if (adminId) {
      fetchPermissions(adminId);
    }
  }, []);

  const fetchPermissions = async (adminId) => {
    try {
      const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
      const data = await response.json();
      setPermissions(data); // 권한 정보를 상태로 설정
    } catch (error) {
      console.error("권한 정보를 가져오는 데 실패했습니다.", error);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    const date = new Date(dateString);
    return date.toLocaleString("ko-KR", options).replace(",", "");
  };

  const indexOfLastBanner = currentPage * itemsPerPage;
  const indexOfFirstBanner = indexOfLastBanner - itemsPerPage;
  const currentBanners = banners.slice(indexOfFirstBanner, indexOfLastBanner);
  const totalPages = Math.ceil(banners.length / itemsPerPage);

  // 페이지 범위 설정
  const pageRange = 10; // 최대 페이지 번호 개수
  const startPage = Math.floor((currentPage - 1) / pageRange) * pageRange + 1;
  const endPage = Math.min(startPage + pageRange - 1, totalPages);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePreview = (banner) => {
    setPreviewBanner(banner);
  };

  // 검색어 변경 처리
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // 검색 기준 변경 처리
  const handleSearchOptionChange = (event) => {
    setSearchOption(event.target.value);
  };

  // 검색 버튼 클릭 처리
  const handleSearchClick = async (e) => {
    e.preventDefault(); // 버튼 기본 동작 방지

    if (searchTerm.trim() === "") {
      // 검색어가 없으면 전체 배너를 다시 로딩
      setBanners(allBanners); // 전체 배너 데이터로 복원
    } else {
      // 검색어가 있을 경우, 검색 기준에 맞춰서 필터링
      const filteredBanners = allBanners.filter((banner) => {
        if (searchOption === "title") {
          // 제목을 기준으로 검색
          return banner.title.toLowerCase().includes(searchTerm.toLowerCase());
        } else if (searchOption === "writer_id") {
          // 작성자를 기준으로 검색
          return banner.name.toLowerCase().includes(searchTerm.toLowerCase());
        }
        return false;
      });
      setBanners(filteredBanners); // 필터링된 배너로 업데이트
    }
  };

  const handleSortClick = () => {
    setShowSortModal(true); // 모달 열기
  };

  const handleSortSave = (updatedBanners) => {
    setBanners(updatedBanners); // UI 업데이트
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="main_banner">
        <div className="path-sec">
          HOME &gt; <span className="menu1">사이트 관리</span> &gt;
          <span className="menu2"> 메인배너 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">사이트 관리</h3>
                <ul className="snb_list">
                  {permissions.banner && (
                    <li className="cur">
                      <a href="/admin/site/banner">메인배너 관리</a>
                    </li>
                  )}
                  {permissions.popup && (
                    <li>
                      <a href="/admin/site/popup">팝업배너 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td className="right_m">
              <div className="sec-cont">
                <form name="delfrm">
                  <input type="hidden" name="mode" value="chk_del" />
                  <div className="tb_01">
                    <div className="bx_sch_btm bg_1">
                      <select
                        name="search"
                        id="search"
                        className="inputTxt"
                        value={searchOption}
                        onChange={handleSearchOptionChange}
                      >
                        <option value="title">제목</option>
                        <option value="writer_id">작성자</option>
                      </select>
                      <input
                        type="text"
                        name="strsearch"
                        id="strsearch"
                        className="inputTxt"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <button
                        className="btn info"
                        onClick={handleSearchClick} // 검색 버튼 클릭 시 동작
                      >
                        검색
                      </button>
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>번호</th>
                          <th>제목</th>
                          <th>미리보기</th>
                          <th>사용여부</th>
                          <th>팝업기간</th>
                          <th>등록일</th>
                          <th>작성자</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentBanners.length > 0 ? (
                          currentBanners.map((banner, index) => (
                            <tr key={banner.Idx}>
                              <td>
                                {banners.length - indexOfFirstBanner - index}
                              </td>
                              <td className="tit">
                                <Link to={`/admin/site/Bview/${banner.idx}`}>
                                  {banner.title}
                                </Link>
                              </td>
                              <td>
                                <span className="btn1">
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault(); // 기본 동작 방지
                                      handlePreview(banner); // 미리보기 함수 호출
                                    }}
                                    style={{
                                      backgroundColor: "#fff",
                                      fontSize: "15px",
                                    }}
                                  >
                                    미리보기
                                  </button>
                                </span>
                              </td>
                              <td>
                                {banner.useYn === "Y" ? "사용" : "사용안함"}
                              </td>
                              <td>{`${banner.popStart} ~ ${banner.popEnd}`}</td>
                              <td>{formatDate(banner.logDate)}</td>
                              <td>{banner.name}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                              등록된 내용이 없습니다.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
              <div className="sec-btn-btn">
                <span className="btn custom_s">
                  <button onClick={handleSortClick}>배너 정렬</button>
                  {showSortModal && (
                    <BannerSortModal
                      onClose={() => setShowSortModal(false)}
                      onSave={handleSortSave}
                    />
                  )}
                </span>
                <div className="dataTables_paginate">
                  <button
                    className="paginate_button previous"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    이전
                  </button>
                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, index) => (
                      <button
                        key={startPage + index}
                        className={`paginate_button ${
                          currentPage === startPage + index ? "active" : ""
                        }`}
                        onClick={() => handlePageChange(startPage + index)}
                      >
                        {startPage + index}
                      </button>
                    )
                  )}
                  {endPage <= totalPages && (
                    <button
                      className="paginate_button next"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      다음
                    </button>
                  )}
                </div>
                <span className="btn custom_r">
                  <button onClick={() => navigate("/admin/site/Bwrite")}>
                    등록
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      {previewBanner && (
        <div className="miribogi">
          <div className="miri-content">
            <span className="close" onClick={() => setPreviewBanner(null)}>
              X
            </span>
            <a href={previewBanner.url1} target="_blank" rel="noreferrer">
              <img
                src={`/static/DATA/banner/${previewBanner.file1}`}
                alt={previewBanner.title}
              />
            </a>
          </div>
        </div>
      )}
      <ADMIN_FOOTER />
    </div>
  );
};

export default Admin_banner;
